
import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateSchedule} from "../../types/api/planRoute/shedule.types";

export const scheduleService = {
    create: (schedule: CreateSchedule) =>
        apiCall.post(apiUrls.planRoute.schedule.create, schedule),

    getAll: () =>
        apiCall.get(apiUrls.planRoute.schedule.create),

    schedulePartsByScheduleId: (scheduleId: string) =>
        apiCall.get(apiUrls.planRoute.schedule.schedulePartsByScheduleId(scheduleId)),

    getByCpId: (cpId: string) =>
        apiCall.get(apiUrls.planRoute.schedule.getByCpId(cpId)),
}